import { keccak_256 } from "@noble/hashes/sha3.js";
import type { WalletChain } from "./types";

export const SIGN_IN_STATEMENT =
  "Sign in with your wallet. This does not send a transaction or cost any fees.";

export const ADD_WALLET_STATEMENT = "Sign to add address to verified list.";

const ADDRESS = /^0x[0-9a-fA-F]{40}$/;

export const checksumAddress = (address: string) => {
  if (!ADDRESS.test(address)) {
    throw new Error(`Not an Ethereum address: ${address}`);
  }

  const body = address.slice(2).toLowerCase();
  const hash = keccak_256(new TextEncoder().encode(body));

  let out = "0x";

  for (let index = 0; index < body.length; index += 1) {
    const nibble = index % 2 === 0 ? hash[index >> 1] >> 4 : hash[index >> 1] & 0xf;
    out += nibble >= 8 ? body[index].toUpperCase() : body[index];
  }

  return out;
};

const HEADING: Record<WalletChain, string> = {
  evm: "Ethereum",
  solana: "Solana",
};

export type SignInMessage = {
  chain: WalletChain;
  domain: string;
  address: string;
  uri: string;
  statement: string;
  chainId: number;
  nonce: string;
  issuedAt: string;
};

export const signInMessage = ({
  chain,
  domain,
  address,
  uri,
  statement,
  chainId,
  nonce,
  issuedAt,
}: SignInMessage) =>
  [
    `${domain} wants you to sign in with your ${HEADING[chain]} account:`,
    address,
    "",
    statement,
    "",
    `URI: ${uri}`,
    "Version: 1",
    `Chain ID: ${chainId}`,
    `Nonce: ${nonce}`,
    `Issued At: ${issuedAt}`,
  ].join("\n");
